// Where page data comes from. Production builds always use the ORCA API; a
// development build opened with `?dev=…` (the DEV scenario panel, the e2e
// suites) keeps the local mock server so every scenario stays reproducible.
export const MOCK_DATA: boolean = import.meta.env.DEV
  && typeof window !== 'undefined'
  && new URLSearchParams(window.location.search).has('dev');
